export default __webpack_public_path__ + "static/imgSSM8-6335264f1d25e48fc9fc1b83126e5608.png";